<template>
  <div class="brands">
    <h1 class="font-semibold text-xl mb-5 flex justify-between items-center">
      <div class="flex-shrink-0">
        Бренды ({{ filteredBrands.length }})
        <i v-if="loading" class="el-icon-loading"></i>
      </div>
      <div class="flex items-center justify-end">
        <el-input
          v-model="query"
          size="medium"
          clearable
          placeholder="Поиск по бренду"
          prefix-icon="el-icon-search"
          class="w-64"
        ></el-input>
      </div>
    </h1>

    <p class="text-gray-500 text-sm mb-4">
      Скидка применяется ко всем товарам бренда, у которых не задана собственная
      скидка. Своя скидка товара всегда главнее.
    </p>

    <el-table :data="filteredBrands" border size="small" v-loading="loading">
      <el-table-column
        type="index"
        :index="(index) => index + 1"
        width="50"
        label="N"
        align="center"
      ></el-table-column>
      <el-table-column prop="brand" label="Бренд"></el-table-column>
      <el-table-column
        prop="products_count"
        label="Товаров"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column label="Скидка, %" width="200" align="center">
        <template slot-scope="{ row }">
          <el-input-number
            v-model="row.discount"
            :min="0"
            :max="100"
            :step="1"
            size="small"
            controls-position="right"
            :disabled="savingBrand === row.brand"
            @change="(value, previous) => saveDiscount(row, value, previous)"
          ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBrands, saveBrandDiscount } from "@/api/brands";

export default {
  name: "BrandsList",
  data() {
    return {
      brands: [],
      query: "",
      loading: false,
      savingBrand: null,
    };
  },
  computed: {
    filteredBrands() {
      const query = this.query.trim().toLowerCase();
      if (!query) {
        return this.brands;
      }
      return this.brands.filter((brand) =>
        (brand.brand || "").toLowerCase().includes(query)
      );
    },
  },
  async created() {
    await this.fetchBrands();
  },
  methods: {
    async fetchBrands() {
      this.loading = true;
      try {
        const { brands } = await getBrands();
        this.brands = brands || [];
      } catch (error) {
        console.error("Ошибка при получении брендов:", error);
        this.$message.error("Не удалось загрузить бренды");
      } finally {
        this.loading = false;
      }
    },
    // v-model уже записал новое значение в row.discount, поэтому для отката
    // берём предыдущее значение из второго аргумента el-input-number.
    async saveDiscount(row, value, previous) {
      this.savingBrand = row.brand;
      try {
        const result = await saveBrandDiscount(row.brand, value);
        if (!result.success) {
          row.discount = previous;
          this.$message.error(result.message || "Не удалось сохранить скидку");
          return;
        }
        this.$message.success(
          value > 0
            ? `Скидка ${value}% на бренд ${row.brand} сохранена`
            : `Скидка на бренд ${row.brand} убрана`
        );
      } catch (error) {
        console.error("Ошибка при сохранении скидки бренда:", error);
        row.discount = previous;
        this.$message.error("Не удалось сохранить скидку");
      } finally {
        this.savingBrand = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brands {
  table {
    th {
      padding: 10px;
    }
    td {
      padding: 10px;
    }
  }
}
</style>
